
import { Component, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { RECUPERAR_SENHA } from '../../app.constants';
import { throttle } from '../shared/decorators/throttle';
import { RecuperarSenha } from '../shared/dominios/recuperar-senha';
import { MessageUtil } from '../shared/messages/messageUtil';
import { FuncoesCriptografia } from '../shared/util/Funcoes-criptografia';
import { FuncoeslimparFormatacao } from '../shared/util/funcoes-limpar-formatacao';
import { StorafeUtil } from '../shared/util/storasge.util';
import { LoginService } from './../login/service/login.service';
import { ValidacaoUtil } from './../shared/util/validacao.util';
import { RecuperarSenhaService } from './service/recuperar-senha.service';
import { PUBLIC_KEY } from '../../app.constants';

declare let grecaptcha: any;



@Component({
  selector: 'app-recuperar-senha',
  templateUrl: './recuperar-senha.component.html',
  styleUrls: ['./recuperar-senha.component.css']
})
export class RecuperarSenhaComponent implements OnInit {




  @BlockUI() blockUi: NgBlockUI;

  selecaoTela = 'recoverPassword';
  localForm: any;
  tipoCampo = 'password';
  recoverPass = '';
  tipoContato: number;
  cpf = '';

  exibirHomeIndexEmitter = new EventEmitter<boolean>();

  isCaptchSelecionado = false;

  captchaKey = PUBLIC_KEY;

  recuperarSenha = new RecuperarSenha();

  tokenError = false;
  maxlengthValue: string;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private recoverPasswordService: RecuperarSenhaService,
    private toastrService: ToastrService
  ) { }


  ngOnInit() {
    //this.loginService.captcha().then(captcha => {this.captchaKey = captcha.captcha })
  }

  reloadCaptcha() {
    grecaptcha.reset();
  }


  resolved(captchaResponse: string) {
    if (captchaResponse === null) {
      this.isCaptchSelecionado = false;
    }else {
      this.isCaptchSelecionado = true;
    }
}

  // ----------------------------------------------------------------------
  // Função para verificar se existe o E-mail no banco da CENTRUS
  @throttle()
  async recoverPassword(formRP) {
    if (ValidacaoUtil.isNullOrEmpty(this.cpf)
      || ValidacaoUtil.isNullOrEmpty(this.recoverPass)) {
      this.toastrService.error(MessageUtil.CAMPOS_OBRIGATORIOS);
      return;
    }

    if (!this.recuperarSenha.nrCpf) { this.recuperarSenha.nrCpf = FuncoeslimparFormatacao.limparDados(this.cpf) };

    await this.loginService
      .loginGetToken()
      .then(async (token) => {
        sessionStorage.clear();
        if (!formRP.invalid) {
          this.blockUi.start();
          await this.recoverPasswordService.saveToken(this.recuperarSenha, token)
            .then(() => this.sendAPI())
            .catch(error => this.toastrService.error(MessageUtil.DADOS_NAO_ENCONTRADOS))
          this.blockUi.stop();
        }
      })
      .catch(() => this.toastrService.error(MessageUtil.TOKEN_FALHA))
  }

  // Função para enviar o email e token para as APIs
  async sendAPI() {
    await this.loginService
      .loginGetToken()
      .then(async () => {

        await this.recoverPasswordService.sendAPI(this.recuperarSenha, this.tipoContato)
          .then(() => {
            const recuperarSenha = {
              'dsEmail': this.recuperarSenha.dsEmail,
              'nrFone': this.recuperarSenha.nrFone,
              'tipoContato': this.tipoContato,
              'nrCpf': this.recuperarSenha.nrCpf
            }

            StorafeUtil.gravaSessionStorage(RECUPERAR_SENHA, recuperarSenha);

           // this.router.navigateByUrl('recuperarSenha/codigoAcesso');
           this.router.navigate(['recuperarSenha/codigoAcesso'], { skipLocationChange: true })
            this.toastrService.success(MessageUtil.FASE_AVANCADA_SUCESSO)
          })
          .catch(() => this.toastrService.error(MessageUtil.TOKEN_FALHA))

      })
      .catch(() => this.toastrService.error(MessageUtil.TOKEN_FALHA))
  }


  maxlengthCheck(tipo) {
    this.maxlengthValue = '';
    const cpf = FuncoeslimparFormatacao.limparDados(this.cpf);
    const token = FuncoesCriptografia.GenerateKey();
    if (FuncoesCriptografia.verificarTipo(tipo) === '1') {
      this.maxlengthValue = '200';
      this.tipoContato = 1
      this.recuperarSenha = new RecuperarSenha(token, this.recoverPass, null, cpf);
    } if (FuncoesCriptografia.verificarTipo(tipo) === '2') {
      this.maxlengthValue = '16';
      this.tipoContato = 2
      this.recuperarSenha = new RecuperarSenha(token, null, Number(this.recoverPass), cpf);
    }
  }

}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/recuperar-senha/recuperar-senha.component.ts